import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useContext, useRef, useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { useDialogExpansionContext } from '../../dialog-expansion-context';
import { useSessionUserInput } from '../../user-input-provider';
import { FilterOptionSource } from '../../../common/filters/types';
import { useFilterStore } from '../filter-store';
import { SITE_FILTER_TYPE_NAME } from '../filter-types';
import { messages } from '../../../messages';
export var ProductFilterContext = /*#__PURE__*/React.createContext({
  filterDefinitions: {},
  defineFilters: function defineFilters() {}
});
export var FilterContextHOC = function FilterContextHOC(_ref) {
  var children = _ref.children;
  var filterDefinitions = useRef({}).current;
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  var _useSessionUserInput = useSessionUserInput(),
    stickySearchEnabled = _useSessionUserInput.stickySearchEnabled,
    resetExtensibleFiltersRef = _useSessionUserInput.resetExtensibleFiltersRef;
  var previousExpandState = useRef(isExpanded);
  var defineFilters = function defineFilters(productId, filters) {
    filterDefinitions[productId] = filters;
  };
  var resetFilters = function resetFilters() {
    Object.keys(filterDefinitions).forEach(function (productId) {
      filterDefinitions[productId].forEach(function (filter) {
        filter.store.reset();
      });
    });
  };
  useEffect(function () {
    if (previousExpandState.current && !isExpanded && !stickySearchEnabled) {
      Object.keys(filterDefinitions).forEach(function (productId) {
        filterDefinitions[productId].forEach(function (filter) {
          filter.store.reset();
        });
      });
    }
    previousExpandState.current = isExpanded;
  }, [isExpanded, stickySearchEnabled]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    if (resetExtensibleFiltersRef) {
      resetExtensibleFiltersRef.current = resetFilters;
    }
  }); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(ProductFilterContext.Provider, {
    value: {
      filterDefinitions: filterDefinitions,
      defineFilters: defineFilters
    }
  }, children);
};
export var useGenericFilters = function useGenericFilters() {
  return useContext(ProductFilterContext);
};
export var useSiteFilterDefinition = function useSiteFilterDefinition(workspaces, productId) {
  var isMultiWorkspace = workspaces && workspaces.length > 1;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var siteFilterStore = useFilterStore(workspaces === null || workspaces === void 0 ? void 0 : workspaces.map(function (workspace, index) {
    return {
      label: workspace.name,
      id: workspace.id,
      isChecked: false,
      isVisible: index < 3,
      filterSource: FilterOptionSource.EXTERNAL,
      avatarUrl: ''
    };
  }), productId, SITE_FILTER_TYPE_NAME);
  if (isMultiWorkspace) {
    return [{
      '@type': SITE_FILTER_TYPE_NAME,
      fieldName: 'values',
      store: siteFilterStore,
      loadFilterOptions: function () {
        var _loadFilterOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", []);
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function loadFilterOptions() {
          return _loadFilterOptions.apply(this, arguments);
        }
        return loadFilterOptions;
      }(),
      sectionLabel: formatMessage(messages.site_filters_title),
      findMoreLabel: formatMessage(messages.site_filters_find_more)
    }];
  } else {
    return [];
  }
};